export default {
  name: 'etoile',
  title: 'Outil Polygone/Etoile',
  buttons: [
    {
      title: 'Outil Etoile'
    },
    {
      title: 'Outil Polygone'
    }
  ],
  contextTools: [
    {
      title: 'Nombre de côtés',
      label: 'points'
    },
    {
      title: 'Précision',
      label: 'Précision'
    },
    {
      title: 'Torsion Etoile',
      label: 'Décalage Radial'
    },
    {
      title: 'Nombre de côtés',
      label: 'côtés'
    }
  ]
}
